import game.Game
import game.Room
import game.entity.Entity

class TentacleWall: Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById("tentacle-wall")
        width = 5
        height = 1
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.player.takeDamage(1)

        return false
    }
}